/* eslint-disable no-console */
import React from 'react';

import {formatIndian} from '../../../../utils/formatIndian';
import RenderCustomizedLabelScopeProps from '../interfaces/RenderCustomScopeProps';

const RenderCustomizedLabelScope: React.FC<RenderCustomizedLabelScopeProps> = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  payload,
  value
}) => {
  const RADIAN = Math.PI / 180;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 4) * cos;
  const sy = cy + (outerRadius + 4) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 20;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={'#99B1C7'}
        fill="none"
        strokeDasharray="2 2"
      />
      <text
        style={{
          font: 'normal normal 600 12px/15px Montserrat',
          textTransform: 'uppercase',
          color: '#677489'
        }}
        x={ex + (cos >= 0 ? 1 : -1) * 5}
        y={ey}
        textAnchor={textAnchor}
        fill={'#99B1C7'}
      >
        {payload.name}
      </text>
      <text
        x={ex + (cos >= 0 ? 1 : 1) * 5}
        y={ey}
        dy={'7%'}
        dx={'-0%'}
        textAnchor={textAnchor}
        fill={'#99B1C7'}
        style={{
          font: 'normal normal 300 32px/39px Montserrat',
          textAlign: 'left'
        }}
      >
        {formatIndian(value)}
        {'%'}
      </text>
    </g>
  );
};

export default RenderCustomizedLabelScope;
